export const config = {
    appId: '8c0837c8-c29c-4b80-9a55-f026b0d314b8',
    redirectUri: 'https://insai.ai',
    scopes: [
        'user.read'
    ],
    authority: 'https://login.microsoftonline.com/2f42a72c-aa53-4a23-8efc-800930f4ff68/'
}